export function isValidUsOrCanadaZip(zip: string) {
    
    const usZipRegex = /^\d{5}(-\d{4})?$/;
    const caZipRegex = /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;

    return usZipRegex.test(zip) || caZipRegex.test(zip);
}